


































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';

import storeClient from '@/stores/modules/client';

import InputPrixClientsList from '@/components/Input/PrixClientsList.vue';
import {Client} from "@/models";

import storeLongueursVente from "@/stores/modules/longueursVente";

@Component({
	components: {
		InputPrixClientsList,
	}
})
export default class CrudClientEditReglement extends AbstractEditVue<Client> {
	public constructor() {
		super(
			storeClient,
			'Réglement modifié',
			'Réglement créé',
		);
	}

	public async mounted(): Promise<void> {
		await storeLongueursVente.dispatch('getC', {filters:false});
		super.mounted();
	}

}
